export default [
  {
    path: '/tools/activity',
    meta: { auth: 'administrator' },
    component: () =>
      import(/* webpackChunkName: 'support-activity-tool' */ '@/views/tools/SupportActivity'),
  },
  {
    path: '/tools/bundle_errors',
    meta: { auth: 'administrator' },
    component: () =>
      import(/* webpackChunkName: 'bundle-errors-tool' */ '@/views/tools/BundleErrors'),
  },
  {
    path: '/tools/verification',
    meta: { auth: 'administrator' },
    component: () =>
      import(/* webpackChunkName: 'verification-tool' */ '@/views/tools/Verification'),
  },
]
